import { use, type ReactNode } from "react";
import { createPortal } from "react-dom";

import { SectionActionsContext } from "@/components/shell/section-actions";

/**
 * A screen's primary action, drawn in the page header (#637). Renders nothing
 * where there is no header slot, so a screen used outside a section simply has
 * no header button.
 */
export function SectionAction({ children }: { children: ReactNode }) {
  const slot = use(SectionActionsContext);
  return slot ? createPortal(children, slot) : null;
}
